module.exports = __webpack_public_path__ + "static/media/Artboard1.0b38ec5d.png";